import { useMutation } from '@apollo/client'
import { ReactElement, useEffect } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import FormLayoutV2 from 'components/v2/FormLayout'
import { ForbiddenView } from 'features/App/components/ForbiddenView'
import { withLastUrl } from 'features/App/components/WithLastUrl'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { INewServicesForm } from 'features/Services/components/NewServicesV2/types'
import { NewTrip } from 'features/Trips/components/NewTrip'
import { CREATE_TRIP } from 'features/Services/mutations-legacy'
import { mapServicesFormToServicesInput } from 'models/services'
import { useLogin } from 'features/Login/hooks'
import { canCreateTrip } from 'features/Users/utils'

const messages = defineMessages({
  helmet: {
    id: 'trips.create.helmet',
    defaultMessage: 'Create Trip | Nexbus Admin'
  }
})

const NewTripView = (): ReactElement => {
  const intl = useIntl()
  const navigate = useNavigate()
  const login = useLogin()

  const userCanCreateTrip = canCreateTrip(login.accessToken.policies)

  const [createTrip, { loading, error }] = useMutation(CREATE_TRIP)

  const handleSubmit = async (services: INewServicesForm): Promise<void> => {
    //Send trip reason here.
    try {
      const servicesInput = mapServicesFormToServicesInput(services)
      const service = servicesInput[0]
      await createTrip({
        variables: {
          input: {
            companyLineID: service.companyLineID,
            date: service.itinerariesSchedule?.[0].startAt,
            routeID: service.itinerariesSchedule?.[0].routeID,
            vehicleID: service.vehiclesSchedule?.[0].vehicleID,
            itinerary: service.itinerariesSchedule?.[0].itinerary,
            reason: services.reason
          }
        }
      })

      navigate('/trips')
    } catch (error) {
      // Do nothing
    }
  }

  useEffect((): void => {
    document.title = intl.formatMessage(messages.helmet)
  }, [])

  if (!userCanCreateTrip) {
    return <ForbiddenView feature={FEATURES.SERVICE} />
  }

  return (
    <FormLayoutV2.Container>
      <NewTrip loading={loading} error={error} onSubmit={handleSubmit} />
    </FormLayoutV2.Container>
  )
}

export default withLastUrl(NewTripView)
